import { CalendarProvider, WeekStartDays } from "@clockwise/web-commons/src/util/CalendarContext";
import { DateTime } from "luxon";
import React from "react";
import Helmet from "react-helmet";
import Context from "../chat-plus-calendar/Context";
import { StorageKeyPrefixProvider } from "../web-app-calendar/hooks/useStorageKeyPrefix";
import { ClockwiseMini } from "./ClockwiseMini";

export const RootMini = () => {
  const calendarProviderInit = {
    // I don't love the recent explosion of providers as there is no compile-time way to know what is needed by what. Or what consumes what.
    // Feels like a step backwards from the old redux store in this regard to me. Maybe we should enforce that all providers are all provided at the top level?
    // Or maybe treat data and functions coming from providers as always optional and have the consuming component handle the case where they are not provided w/o invariant errors?
    focusedDate: DateTime.now().toISODate(),
    visibleDates: [DateTime.now().toISODate()],
    weekendsShown: true,
    weekStartDay: "monday" as WeekStartDays,
  };

  return (
    <>
      <Helmet>
        <meta name="robots" content="noindex" />
      </Helmet>
      <StorageKeyPrefixProvider prefix="mini">
        <Context>
          <CalendarProvider initValue={calendarProviderInit}>
            <ClockwiseMini />
          </CalendarProvider>
        </Context>
      </StorageKeyPrefixProvider>
    </>
  );
};
